export default __webpack_public_path__ + "static/5-f67574aa1c2a2c2a283588f31feb17b6.png";